import { render, staticRenderFns } from "./EMEquipmentRatesList.vue?vue&type=template&id=5c3b08a4&scoped=true"
import script from "./EMEquipmentRatesList.vue?vue&type=script&lang=js"
export * from "./EMEquipmentRatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b08a4",
  null
  
)

export default component.exports